import React from "react";
import LinearProgress from "@mui/material/LinearProgress";
import { Box } from "@mui/material";

const progressBarStyle = {
  zIndex: 2000,
  position: "fixed" as const,
  top: 0,
  left: 0,
  width: "100%",
} as const;

interface ProgressBarProps {
  isVisible: boolean;
}

function ProgressBarImpl({ isVisible }: ProgressBarProps): JSX.Element | null {
  if (!isVisible) return null;

  return (
    <Box sx={progressBarStyle} aria-label="Loading progress">
      <LinearProgress color="primary" /* transitionDuration={0} */ />
    </Box>
  );
}

// Only re-render when visibility changes
export default React.memo(ProgressBarImpl, (a, b) => a.isVisible === b.isVisible);
